import { createFileRoute } from '@tanstack/react-router'
import { ScheduleScreen } from '../features/schedule'

type ScheduleSearch = {
  tab?: 'calendar' | 'pipeline'
  drawer?: boolean
  caseId?: string
  customer?: string
  wo?: string
  workOrder?: string
  notification?: string
}

export const Route = createFileRoute('/schedule')({
  validateSearch: (search: Record<string, unknown>): ScheduleSearch => ({
    tab: search.tab === 'pipeline' ? 'pipeline' : search.tab === 'calendar' ? 'calendar' : undefined,
    drawer: search.drawer === true || search.drawer === 'true' ? true : undefined,
    caseId: typeof search.caseId === 'string' ? search.caseId : undefined,
    customer: typeof search.customer === 'string' ? search.customer : undefined,
    wo: typeof search.wo === 'string' ? search.wo : undefined,
    workOrder: typeof search.workOrder === 'string' && /^[0-9a-f-]{36}$/i.test(search.workOrder) ? search.workOrder : undefined,
    notification: typeof search.notification === 'string' && /^[0-9a-f-]{36}$/i.test(search.notification) ? search.notification : undefined,
  }),
  component: function ScheduleRoute() {
    const search = Route.useSearch()
    return <ScheduleScreen search={search} />
  },
})
